export default __webpack_public_path__ + "static/media/cuttingComb.8331fbac.jpg";